module.exports = __webpack_public_path__ + "img/antes_despues_209.b5c71855.png";